import { Component, OnInit } from '@angular/core';
import { catchError, finalize } from 'rxjs/operators';
import { RegistrationService } from '../../../../shared/services/auth/registration.service';
import { verifyCodeErrorMessages } from '../../../model/verify-code-error-messages';
import { AnalyticsFormService } from '../../../../core/services/analytics-form.service';
import { EmailVerificationForm } from '../../../../shared/forms/auth/register.form';
import { ActivatedRoute, Router } from '@angular/router';
import { throwError } from 'rxjs';
import { LoaderButtonType } from '../../../../shared/models/loader-button-type.enum';

@Component({
standalone: false,
  selector: 'app-step-email-verification',
  templateUrl: './step-email-verification.component.html',
  styleUrls: ['./step-email-verification.component.scss'],
})
export class StepEmailVerificationComponent implements OnInit {
  public sentCode = false;
  public form = new EmailVerificationForm(null);
  public formName = 'verifyEmail';
  public loading = false;
  public errors: string[];
  public errorMessages = verifyCodeErrorMessages;
  public submitted = false;

  constructor(private registrationService: RegistrationService, private router: Router,
              private route: ActivatedRoute,
              private analyticsFormService: AnalyticsFormService) {
  }

  ngOnInit(): void {
    if (this.registrationService.getCode()) {
      this.form.code.setValue(this.registrationService.getCode());
      this.form.code.markAsTouched();
    }
  }


  public onGoBackClick() {
    this.router.navigate(['./'], {
      relativeTo: this.route,
      queryParams: {},
    });
    this.registrationService.backToFirstStep();
  }

  public onSendCodeClick() {
    this.sentCode = true;

    this.registrationService
      .resendVerificationEmail()
      .pipe(
        catchError((errors) => {
          this.errors = errors?.error?.errorCodes;
          this.form.code.setErrors({ [errors]: true });
          this.analyticsFormService.sendEventForCaughtError('emailVerificationGroup', this.formName);
          return throwError(() => errors);
        }),
        finalize(() => {
          this.loading = false;
          setTimeout(() => {
            this.sentCode = false;
          }, 10000);
        }),
      ).subscribe();
  }

  public onSubmit() {
    this.loading = true;
    if (this.form.invalid) {
      this.submitted = true;
      this.form.markAllAsTouched();
      this.loading = false;
      return;
    }

    this.registrationService
      .verifyEmail(this.form.code.value)
      .pipe(
        catchError((error) => {
          this.submitted = true;
          this.errors = [error];
          this.form.code.setErrors({ error: true });
          this.analyticsFormService.sendEventForCaughtError('emailVerificationGroup', this.formName);
          return throwError(() => error);
        }),
        finalize(() => {
          this.loading = false;
        }),
      ).subscribe();
  }

  protected readonly LoaderButtonType = LoaderButtonType;
}
